<template>
  <modal class="comment" name="add-tag-modal" width="90%" height="auto">
    <Button
      class="close"
      @click.native="$modal.hide('add-tag-modal')"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>
    <h3>{{ title }}</h3>
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>
    <InputField
      unit="#"
      unit-first
      v-model="tagName"
      required
      :placeholder="$t('dash.dictionary.category.form-title')"
    ></InputField>
    <LoadingButton v-if="loading"></LoadingButton>
    <Button
      v-else
      :title="$t('dash.dictionary.action-add')"
      shadow="true"
      @click.native="addTag"
      margin="1rem 0"
    ></Button>
  </modal>
</template>
<script>
import {neoparentTags} from "@/api";

export default {
  name: "TagModal",
  props: {
    title: { required: true }
  },
  data: function() {
    return {
      error: "",
      tagName: "",
      loading: false
    };
  },
  methods: {
    addTag: async function() {
      try {
        if (this.tagName !== "") {
          const data = {
            name: this.tagName
          }
          await neoparentTags.addTag(data).then(() => {
            this.tagName = "";
          })
    /*      await axios
            .post(`${this.$backendRoot}/dictionary/tags/add`, {
              name: this.tagName,
              token: this.$session.get("admin-token")
            })
            .then(response => {
              this.tagName = "";
              this.consoleLog(response);
            });*/
          this.$emit("add-tag");
          this.$modal.hide("add-tag-modal");
        } else {
          this.error = this.$t("error.dictionary.category.missing-title");
        }
      } catch (error) {
        this.consoleLog(error);
      }
    }
  }
};
</script>
